angular.module('CarsSaraBo').service('CacheService',[function(){
	
	return {
	
		data: {},
		
		get: function(key, service, parameters, callback) {
			
			if(!this.data[key]){
				service.query(parameters , function(response) {
					this.data[key] = response;
					callback(response);
				}.bind(this));
			} else {
				callback(this.data[key]);
			}
		},
		
		clean: function(key) {
			
			if(this.data[key]){
				delete this.data[key];
			}
		}
		
	
	};
}]);


//////////////////
// WEBPACK FOOTER
// ./public/app/models/cache_service.js
// module id = 839
// module chunks = 3